const settingsBasePath = '/settings';

const SettingsConst = {
    basePath: settingsBasePath,
    languagesPath: `${ settingsBasePath }/languages`,
    translationAiUsagePath: `${ settingsBasePath }/translation-ai-usage`,
    translationAiRequestsPath: `${ settingsBasePath }/translation-ai-requests`,
};

export default SettingsConst;
